// Copyright (C) 2026 Skylark Drones

import createDOMPurify from 'dompurify'

const DOMPurify = createDOMPurify(window)

export function sanitizeHtml(value) {
  return DOMPurify.sanitize(value == null ? '' : String(value), {
    USE_PROFILES: { html: true }
  })
}
